import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { t } from '@lingui/macro';
import { useLocalisation } from '../../helpers/i18n/use-localisation';
import { constructModal, activateModal } from '../modal/modal-actions';
import { Detector } from './detect-offline';
import { ModalGeneric } from '../../components/modal-content';

const InternetConnectivity = () => {
  const dispatch = useDispatch();
  const [isConnected, setIsConnected] = useState(true);
  const { i18n } = useLocalisation();

  useEffect(() => {
    if (isConnected) {
      dispatch(activateModal(false));
    } else {
      const modalData = {
        header: i18n._(t`Network error!`),
        subHeader: i18n._(t`It looks like you have lost your internet connection.`),
        paragraph: i18n._(t`Please check your internet while we try to reconnect you.`)
      };

      dispatch(constructModal({
        activate: true,
        content: <ModalGeneric modalData={modalData} />,
        canvasOnClick: false
      }));
    }
  }, [isConnected]);

  return (
    <Detector
      render={({ online }) => {
        if (online) {
          setIsConnected(true);
        } else {
          setIsConnected(false);
        }
        return null;
      }}
      polling={{
        url: window._env_.InternetConnectivityPollingUrl
      }}
    />
  );
};

export default InternetConnectivity;
